export default __webpack_public_path__ + "../images/apple-touch-icon-57x57.png";